<template>
  <div id="">
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.name" placeholder="商品编码或名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="el-form-button" type="primary" v-on:click="loadData">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button class="el-form-button" type="success" @click="addInfo">新增</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <el-table
      :data="tableData"
      style="width: 100%"
      row-key="id"
      border
      lazy
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column prop="id" label="ID" width="100"></el-table-column>
      <el-table-column prop="type" label="菜单类型" show-overflow-tooltip width="100">
        <template slot-scope="scope">
          {{ menuTypeMap[scope.row.type] }}
        </template>
      </el-table-column>
      <el-table-column prop="name" label="菜单名称" width="150"></el-table-column>
      <el-table-column prop="platform" label="平台" width="120">
        <template slot-scope="scope">
          {{ platformMap[scope.row.platform] }}
        </template>
      </el-table-column>
      <el-table-column prop="url" label="菜单路径" width="150"></el-table-column>
      <!--第二步  开始进行修改和查询操作-->
      <el-table-column label="操作" align="center" min-width="200">
        <template slot-scope="scope">
          <el-button type="primary" @click="checkDetail(scope.row)">详情</el-button>
          <el-button type="warning" @click="modifyInfo(scope.row)">修改</el-button>
          <el-button type="danger" @click="deleteInfo(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--新增界面-->
    <el-dialog title="记录" :visible.sync="dialogVisible" width="50%" :close-on-click-modal="false">
      <span style="color: red;" v-show="!modifyTag">温馨提示：*如果不选择父级菜单则为新增一级菜单*</span>
      <el-form :model="addFormData" :rules="rules2" ref="addFormData" label-width="150px" class="demo-ruleForm">
        <el-row v-show="!modifyTag">
          <el-col :span="10">
            <el-form-item label="请选择父级菜单">
              <el-popover
                placement="bottom-start"
                width="400"
                trigger="click"
                v-model="treeVisible">
                <div style="text-align: center; margin-bottom: 10px;">
                  <el-button size="mini" type="text" @click="setTopLevel">设为一级菜单</el-button>
                </div>
                <el-tree
                  :data="tree"
                  :props="defaultProps"
                  @node-click="selectNode"
                  style="max-height: 300px; overflow-y: auto;">
                </el-tree>
                <el-input
                  slot="reference"
                  v-model="addFormData.parentLable"
                  placeholder="点击选择父级菜单"
                  readonly>
                </el-input>
              </el-popover>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item prop="parentId" label="父级id">
              <el-input type="text" v-model.trim="addFormData.parentId" disabled placeholder="父级id"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="parentLable" label="父级菜单名">
              <el-input type="text" v-model.trim="addFormData.parentLable" disabled placeholder="父级菜单名"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item prop="name" label="菜单名称">
              <el-input type="text" v-model="addFormData.name" placeholder="菜单名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="url" label="菜单url">
              <el-input type="text" v-model="addFormData.url" placeholder="菜单url"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item prop="platform" label="平台">
              <el-select v-model="addFormData.platform" placeholder="请选择平台" style="width: 100%">
                <el-option label="后台" :value="1"></el-option>
                <el-option label="小程序" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="type" label="类型">
              <el-select v-model="addFormData.type" placeholder="请选择类型" style="width: 100%">
                <el-option label="目录" :value="1"></el-option>
                <el-option label="菜单" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button @click.native="dialogVisible = false">取 消</el-button>
          <el-button v-if="isView" type="primary" @click.native="addSubmit">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>

import axios from 'axios';
import PageGroup from "../template/PageGroup";
import {sysApi} from "../../api/index"
import {HttpResp} from '../../constant/index';

export default {
    components: {PageGroup},
    data() {
        return {
            tableData: [],
            addFormReadOnly: true,
            dialogVisible: false,
            isView: true,
            modifyTag: false,
            treeVisible: false,
            addFormData: {
              id: '',
              level: '',
              parentId: '',
              name: '',
              url: '',
              permissionCode: '',
              style: '',
              platform: '',
              type: ''
            },
            rules2: {
              parentId: [{ required: true, message: '父级id不能为空', trigger: 'blur'}],
              name: [{ required: true, message: '菜单名称不能为空', trigger: 'blur'}],
              url: [{ required: true, message: '菜单url不能为空', trigger: 'blur'}],
              platform: [{ required: true, message: '平台不能为空', trigger: 'change'}],
              type: [{ required: true, message: '类型不能为空', trigger: 'change'}]
            },

            filters: {
                name: ''
            },

          //树形菜单属性。
          tree: [],
          defaultProps: {
            children: 'children',
            label: 'label'
          }
        }
    },
    mounted: function () {
        this.loadData();
    },
    computed: {

    },
    computed: {
      menuTypeMap() {
        return {
          1: '目录',
          2: '菜单'
        };
      },
      platformMap() {
        return {
          1: '后台',
          2: '小程序'
        };
      }
    },
    methods: {
        loadData() {
            sysApi.listMenu().then(data => {
                //console.info(result);
                if(data.code === HttpResp.SUCCUSS){
                    this.tableData = data.data;
                } else {
                  this.$message({
                    type: 'error',
                    message: data.message
                  });
                }
            });
        },
        addInfo() {
            this.addFormData = {
              id: '',
              level: '',
              parentId: 0,
              name: '',
              url: '',
              permissionCode: '',
              style: '',
              platform: '',
              type: ''
            };
            this.isView = true;
            this.modifyTag = false;
            this.dialogVisible = true;
            //加载菜单树
            this.getMenus();
        },
        checkDetail(rowData) {
            this.addFormData = Object.assign({}, rowData);
            this.isView = false;
            this.dialogVisible = true;
        },
        modifyInfo(rowData) {
            this.addFormData = Object.assign({}, rowData);
            this.isView = true;
            this.modifyTag = true;
            this.dialogVisible = true;
            //    this.addFormReadOnly = false;
        },
        deleteInfo(rowData) {
          this.$confirm('是否删除这条记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            sysApi.deleteMenu(rowData.id).then((result) => {
              if(result.code == 0){
                  this.$message({
                    type: 'success',
                    message: "删除成功"
                  });
                this.loadData();
              }else{
                this.$message({
                  type: 'error',
                  message: result.message
                });
              }
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });

        },
        //增加一条记录
        addSubmit() {
            //先判断表单是否通过了判断
            this.$refs.addFormData.validate((valid) => {
                //代表通过验证 ,将参数传回后台
                if (valid) {
                    // 只传递需要的字段
                    let param = {
                      parentId: this.addFormData.parentId,
                      name: this.addFormData.name,
                      url: this.addFormData.url,
                      type: this.addFormData.type,
                      platform: this.addFormData.platform
                    };
                    
                    // 如果是修改,添加id
                    if(this.modifyTag && this.addFormData.id){
                      param.id = this.addFormData.id;
                    }

                    sysApi.saveOrUpdateMenu(param).then((result) => {
                        if (result.code == 1) {
                            this.$message({
                                type: 'success',
                                message: '保存成功',
                            });
                            this.loadData();
                        } else {
                          var msg = result.message;
                            this.$message({
                                type: 'error',
                                message: msg,
                            });
                        }
                        this.dialogVisible = false;
                    });
                }
            });
        },
      getMenus() {
        sysApi.listMenu().then((res) => {
          if(res.code === HttpResp.SUCCUSS){
            this.tree = res.data;
          }else{
            this.$message({
              type: 'info',
              message: `查询数据失败`
            });
          }
        });
      },
      selectNode(data){
        //console.log(data);
        this.addFormData.parentId=data.id;
        this.addFormData.parentLable=data.label;
        this.treeVisible = false;
      },
      setTopLevel(){
        this.addFormData.parentId = 0;
        this.addFormData.parentLable = '';
        this.treeVisible = false;
      }

    }

}
</script>



// WEBPACK FOOTER //
// src/components/sys/SysMenu.vue